import { Box, Button, Typography, Chip, LinearProgress } from '@material-ui/core';
import CustomSlider from 'components/CustomSlider';
import Interweave from 'interweave';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { LessonData, TrailData } from 'services/dataService';

/**
 *
 * @param {[{banner:string name:string description:string description:string liked_course:boolean id_company_course:string assigned: boolean}]} courses
 * @param {(id_company_course: string)=> {}} onLike
 * @param {(id_company_course: string)=> {}} onActionClick
 */
const CoursesSlider = ({
  finished,
  courses,
  onLike,
  onActionClick,
  slidesNumber,
  chip,
  renderOnTrail,
  progress,
  myContents,
  isKnowledgeTrailPage,
  ...props
}) => {
  const { t } = useTranslation(['button']);
  const [slidesToShow, setSlidesToShow] = React.useState(4);
  const [hasEnroll, setHasEnroll] = React.useState()
  const classes = useStyles();
  
  const { id: id_trail } = useParams();
  const { auth } = useSelector((state) => state);
  const userId = auth.id;

  const toFixed = (num, fixed) => {
    fixed = fixed || 0;
    fixed = Math.pow(10, fixed);
    return Math.floor((num || 0) * fixed) / fixed;
  };


const getTrailEnrollment = async () => {
  try {
    const response = await TrailData.getCheckTrailUser(userId, id_trail);
    setHasEnroll(response.data.length > 0);
  } catch (e) {
    toast.error(t('toastify:commons.toast_error_api'));
  }
};

useEffect(() => {
  if (renderOnTrail){
    getTrailEnrollment();
  }
}, [userId, id_trail]);

  const sortElements = renderOnTrail
    ? (a, b) => (a?.order > b?.order ? 1 : -1)
    : (a, b) => (a.name > b.name ? 1 : -1);

  return (
    <CustomSlider
      itens={courses}
      slidesNumber={slidesNumber}
      slidesToShow={slidesToShow}
      setSlidesToShow={setSlidesToShow}
      slideTeste={renderOnTrail ? finished : true}
      {...props}
    >
      {courses?.sort(sortElements)?.map((course, index) => {
        return (
          <div key={index} className={classes.slidesShow}>
            <Box
              className={classes.card}
              style={{ width: slidesToShow <= 2 ? '100%' : 'unset' }}
            >
              <Box>
                <Button
                  onClick={() => {


                    if(!hasEnroll && renderOnTrail) {
                      return;
                    }
                    if (
                      onActionClick &&
                      renderOnTrail &&
                      course?.enabled
                    ) {
                      onActionClick(course?.id);
                      return;
                    }

                    
                    if (
                      (!renderOnTrail && onActionClick && course?.active) ||
                      (!renderOnTrail && onActionClick && !course?.assigned) ||
                      (!renderOnTrail && onActionClick && finished)
                    ) {
                      onActionClick(
                        course?.assigned
                          ? course?.id
                          : course?.id_company_course,
                        course?.assigned
                      );
                    }


                  }}
                >
                  <img
                    className={`${classes.mediaKnowledgeTrail} ${course?.finished ? classes.blurredMedia : ''}`}
                    src={course.banner ? course.banner : 'https://via.placeholder.com/350x208'}
                  />
                  <div className={classes.topHeader}>
                    {course?.finished && (
                      <img
                        className={classes.imgCheck}
                        src={"/images/checkTrails/check_trails.png"}
                        alt="check_trails"
                      />
                    )}
                  </div>
                  {/* <img
                    className={isKnowledgeTrailPage ? classes.mediaKnowledgeTrail : classes.media}
                    src={
                      course.banner
                        ? course.banner
                        : 'https://via.placeholder.com/350x208'
                    }
                  /> */}

                </Button>
                <Box className={classes.cardBody}>
                  {chip && (
                    <Chip
                      label={"Curso"}
                      color={"primary"}
                      size="small"
                      sx={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        fontWeight: "bold",
                        backgroundColor: "#1976d2",
                        color: "#fff"
                      }}
                    />
                  )}
                  <Typography component="span" className={classes.header}>
                    {course.name}
                  </Typography>
                  {!myContents && !renderOnTrail && (
                    <Box className={classes.description}>
                      <Interweave
                        content={
                          course?.description?.length ? course?.description : '-'
                        }
                      />
                    </Box>
                  )}
                  {renderOnTrail && (
                    <Box className={classes.progress}>
                      <Box className={classes.progressBar}>
                        <LinearProgress
                          style={{ width: '100%' }}
                          color="secondary"
                          variant="determinate"
                          value={toFixed(course?.course_progress, 2)}
                        />
                      </Box>
                      <Box className={classes.progressText}>
                        <Typography component="span">
                          {toFixed(course?.course_progress, 0)}%
                        </Typography>
                      </Box>
                    </Box>
                  )}
                  <Box className={classes.action}>
                    {renderOnTrail && (
                      <Box className={classes.accessButton}>
                        <Button
                          size="medium"
                          color="primary"
                          className={classes.actionButton}
                          disabled={!course?.enabled || !hasEnroll}
                          onClick={() => {
                            if (onActionClick && progress) {
                              onActionClick(course?.id);
                            }
                          }}
                        >
                          {t(`button:StudentContent.${course?.finished ? 'btn_completed' : 'btn_start'}`)}
                        </Button>
                      </Box>
                    )}
                    {!renderOnTrail && (
                      <Box className={classes.accessButton}>
                        <Button
                          size="medium"
                          color="primary"
                          className={classes.actionButton}
                          disabled={
                            !finished && course?.assigned && !course?.active
                          }
                          onClick={() => {
                            if (onActionClick) {
                              onActionClick(
                                course?.assigned
                                  ? course?.id
                                  : course?.id_company_course,
                                course?.assigned
                              );
                            }
                          }}
                        >
                          {finished && t(`button:StudentContent.btn_completed`)}
                          {!finished &&
                            t(
                              `button:StudentContent.${course?.assigned && course?.active
                                ? 'btn_start'
                                : course?.assigned && !course?.active
                                  ? 'btn_block'
                                  : 'btn_enroll'
                              }`
                            )}
                        </Button>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </div>
        );
      })}
    </CustomSlider>
  );
};
export default CoursesSlider;